import { render, staticRenderFns } from "./ProfileLivestream.vue?vue&type=template&id=36751a6a&scoped=true&"
import script from "./ProfileLivestream.vue?vue&type=script&lang=js&"
export * from "./ProfileLivestream.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLivestream.vue?vue&type=style&index=0&id=36751a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36751a6a",
  null
  
)

export default component.exports